import React, { useState, useEffect } from 'react';

const Standings = ({ competitionId, statsFeed }) => {
    const [standingsData, setStandingsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const feedURL = process.env.REACT_APP_FEED_URL;

    // Column headers matching the original HTML
    const standingHeadTitle = [
        { key: 'OrderNo', label: 'Pos' },
        { key: 'TeamName', label: 'Team' },
        { key: 'Matches', label: 'Mat' },
        { key: 'Wins', label: 'Won' },
        { key: 'Loss', label: 'Lost' },
        { key: 'Tied', label: 'Tied' },
        { key: 'NoResult', label: 'NR' },
        { key: 'NetRunRate', label: 'NRR' },
        { key: 'ForTeams', label: 'For' },
        { key: 'AgainstTeam', label: 'Against' },
        { key: 'Points', label: 'Pts' }
    ];

    useEffect(() => {
        const fetchStandings = async () => {
            if (!competitionId) return;
            const defaultFeed = `${feedURL}`;
            try {
                setIsLoading(true);
                const response = await fetch(`${statsFeed || defaultFeed}/stats/${competitionId}-groupstandings.js`);
                const text = await response.text();

                // Extract JSON from JSONP response
                const jsonStr = text.match(/\{.*\}/s)?.[0];
                if (!jsonStr) throw new Error("Invalid standings data");

                const data = JSON.parse(jsonStr);
                console.log(data);

                const organizedData = data.category.map(cat => ({
                    Category: cat.Category,
                    points: data.points.filter(point => point.Category === cat.Category)
                }));
                setStandingsData(organizedData);
            } catch (err) {
                console.error("Error fetching standings:", err);
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchStandings();
    }, [competitionId, statsFeed, feedURL]);

    if (isLoading) return <div className="mcLoader pageloader"><div className="loader__inner">Loading... </div></div>;
    if (error) return <div className="noRecord">No Stats Found</div>;
    if (!standingsData.length) return <div className="noRecord">No Stats Found</div>;

    const isNotNull = (value) => value !== null && value !== undefined;

    return (
        <div className="col s12 m12 l12">
            <div id="stadingSmipl" className="">
                {standingsData.map((group, groupIndex) => (
                    <div key={groupIndex}>
                        {isNotNull(group.Category) && (
                            <h3 className="pageTitle blueTxt fl w1">{group.Category}</h3>
                        )}
                        <table id={`points-table-${groupIndex}`} className="tableDefaultSmipl tablePoints" cellSpacing="0" cellPadding="0" border="0">
                            <thead>
                                <tr>
                                    {standingHeadTitle.map((header, index) => (
                                        <th key={index} data-val={header.key} data-key={index} className=" ">
                                            {header.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {group.points && group.points.length > 0 && (
                                    group.points.map((team, teamIndex) => (
                                        <tr key={teamIndex}>
                                            <td>{team.OrderNo}</td>
                                            <td>{team.TeamName}</td>
                                            <td>{team.Matches}</td>
                                            <td>{team.Wins}</td>
                                            <td>{team.Loss}</td>
                                            <td>{team.Tied}</td>
                                            <td>{team.NoResult}</td>
                                            <td>{team.NetRunRate ? Number(team.NetRunRate).toFixed(3) : '-'}</td>
                                            <td>{team.ForTeams}</td>
                                            <td>{team.AgainstTeam}</td>
                                            <td>{team.Points}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>


                        </table>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Standings;